module.exports = __webpack_public_path__ + "media/images/metronic/social/reddit-1842e7c768d1379d4be05a60afb8f1e0.png";